import React, { useState } from "react";

function Tabs(props){

    const { Components } = props;
    const [state, setState] = useState(0);

    function switchPage(pageName){
        setState(pageName);
    }

    return(
        <div>
            {Array.isArray(Components) && Components.length > 0 &&
            <div>
                <div style= {{ marginTop: '-33px', marginLeft: '-5px' }}>
                    {Components.map((obj, index)=>((
                        <button 
                        className={state === index ? "inactiveTab" : "accountTabs"} 
                        onClick={()=>switchPage(index)}
                    >

                        {obj.label}

                    </button>
                    )))}
                    
                </div>

                <div>
                    {Components[state].html}
                </div>
            </div>
            }
        </div>
    );

}

export default Tabs;
